export default "__VITE_ASSET__CZ5fsuNg__"